import WalletRewardType1 from "./WalletRewardType1";

export default WalletRewardType1;
